<template>
  <section class="banner">
    <div class="banner__wrapper">
      <MainPageAnimation />

      <div class="banner__container">
        <BaseTitle :tag="'h1'" :text="titleText" class="banner__title" />
        <BaseText :text="descriptionText" class="banner__descr" />
      </div>
    </div>
  </section>
</template>

<script>
import { Helper } from '~/mixins/Helper'
import PlayVideoIcon from '~/components/_SVG/PlayVideoIcon.vue'
import MainPageAnimation from '~/components/MainPageAnimation'

export default {
  name: 'BannerBlock',
  data() {
    return {
      modal: {
        width: '',
        height: ''
      }
    }
  },
  computed: {
    titleText() {
      return this.messages.index.banner.title
    },
    descriptionText() {
      return this.messages.index.banner.text
    },
    videoLink() {
      return this.messages.index.banner.videoLink
    }
  },
  mixins: [Helper],
  components: {
    PlayVideoIcon,
    MainPageAnimation
  }
}
</script>

<style lang="scss">
.banner {
  &__wrapper {
    position: relative;
    padding: 60px 16px 100px;

    .main-animation {
      margin: 0 -16px;
    }
  }

  &__container {
    @include container;
    max-width: 100%;
    position: relative;
    z-index: 1;
    // pointer-events: none;
  }

  &__title.title {
    margin: 20px 0;
    text-align: center;
  }

  &__descr {
    font-family: $ToyotaBook;
    margin: 0;
    word-break: break-word;
  }

  &__play {
    @include horizontal-center;
    @include button-reset;

    z-index: 1;
    bottom: 100px;
  }
}

iframe {
  width: 100%;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@include media-min($tablet-width) {
  .banner {
    &__wrapper {
      padding: 60px 25px 100px;

      .main-animation {
        margin: 0 -25px;
      }
    }

    &__title.title {
      margin: 30px 0;
      font-size: 36px;
      line-height: 1;
    }

    &__descr {
      padding-right: 0;
    }
  }
}

@include media-min($desktop-width) {
  .banner {
    &__wrapper {
      position: relative;
      padding: 100px 60px 150px;

      .main-animation {
        margin: 0 -60px;
      }
    }

    &__title.title {
      margin: 40px 0;
      font-size: 36px;
      line-height: 1;
    }

    &__descr {
      padding-right: 0;
    }

    &__play {
      bottom: 113px;
      left: 35%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/BannerBlock.vue